import React, { useCallback } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { styled, useTheme } from '@mui/material/styles'
import { WearInput } from './WearInput'
import withPropsChecker from 'components/withWhatPropChanged'

const StyledDialog = styled(Dialog)(({ theme, isMobile }) => ({
  '& .MuiPaper-root': {
    background: theme.palette.supporting.black,
    ...(isMobile && {
      width: '100%',
      margin: '0'
    })
  }
}))

export const WearInputModal = withPropsChecker(
  React.memo(function WearInputModal_({
    deckRevision,
    maintenance,
    isMobile,
    selectedPanels = [],
    handleClose,
    onWearSubmit,
    database
  }) {
    const theme = useTheme()
    const currentPanel = selectedPanels[0]

    const onSubmit = useCallback(
      (data) => {
        onWearSubmit(data)
        handleClose()
      },
      [onWearSubmit, handleClose]
    )

    return (
      <StyledDialog theme={theme} isMobile={isMobile} onClose={handleClose} fullWidth open>
        <DialogTitle variant="h5">Update Wear Value</DialogTitle>

        <DialogContent>
          <WearInput
            database={database}
            data={{ deckRevision, maintenance }}
            panel={currentPanel}
            onSubmit={onSubmit}
          />
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" color="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="secondary" form="form" type="submit">
            Confirm
          </Button>
        </DialogActions>
      </StyledDialog>
    )
  }),
  'WearInput'
)
